<div class="tenant-settings">
    <div class="role-list" style="max-height: 700px; margin-top: 0px">
        <table>
            <thead>
                <tr>
                    <th>Rubii Account</th>
                    <th>{{data.source.statusList?.name}}</th>
                    <th>Status</th>
                    <th><div>Data Last Processed</div><div class="subtitle">Please allow 1hr to see data</div></th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of statusList">
                    <td class="td-left">{{row.email}}</td>
                    <td class="td-left">{{row.identifier}}</td>
                    <td class="td-left" [style.color]="row.color">{{row.status}}</td>
                    <td class="td-left">{{row.lastModified}}</td>
                    <td class="td-left"><div class="rb rb-icon-delete delete" (click)="delete(row)"></div></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
